/* tslint:disable */
/* eslint-disable */
/**
 * Payment Service API
 * 통합 정리된 결제 서비스 API 명세 - 완전 React 마이그레이션  **주요 개선사항:** - 모든 Thymeleaf 페이지를 REST API로 변환 - 기능별 그룹화된 경로 구조 - 표준화된 응답 형식 - React SPA 완전 지원  **API 구조:** - 결제수단 관리: `/api/v1/payment-methods/_*` - 구독 관리: `/api/v1/subscriptions/_*`  - 플랜 관리: `/api/v1/plans/_*` - 주문 관리: `/api/v1/orders/_*` - 대시보드: `/api/v1/dashboard/_*` - NicePay 결제: `/api/v1/payment/nicepay/_*` - 세션 관리: `/api/v1/auth/_*` 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AggregatedMetrics } from '../models';
// @ts-ignore
import type { MetricDto } from '../models';
// @ts-ignore
import type { MetricsExportRequest } from '../models';
// @ts-ignore
import type { QueryMetrics401Response } from '../models';
// @ts-ignore
import type { TrackMetric200Response } from '../models';
// @ts-ignore
import type { TrackMetricRequest } from '../models';
/**
 * MetricsApi - axios parameter creator
 * @export
 */
export const MetricsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Export metrics
         * @param {MetricsExportRequest} metricsExportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportMetrics: async (metricsExportRequest: MetricsExportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricsExportRequest' is not null or undefined
            assertParamExists('exportMetrics', 'metricsExportRequest', metricsExportRequest)
            const localVarPath = `/api/v1/metrics/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(metricsExportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get aggregated metrics
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregatedMetrics: async (startDate: string, endDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getAggregatedMetrics', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getAggregatedMetrics', 'endDate', endDate)
            const localVarPath = `/api/v1/metrics/aggregated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get available metric types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetricTypes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/metrics/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get metrics summary
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetricsSummary: async (startDate: string, endDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getMetricsSummary', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getMetricsSummary', 'endDate', endDate)
            const localVarPath = `/api/v1/metrics/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Query metrics
         * @param {string} startDate Start date for metrics query
         * @param {string} endDate End date for metrics query
         * @param {QueryMetricsTypeEnum} [type] Metric type filter
         * @param {QueryMetricsGroupByEnum} [groupBy] Group metrics by time period
         * @param {string} [limit] Maximum number of results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryMetrics: async (startDate: string, endDate: string, type?: QueryMetricsTypeEnum, groupBy?: QueryMetricsGroupByEnum, limit?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('queryMetrics', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('queryMetrics', 'endDate', endDate)
            const localVarPath = `/api/v1/metrics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (groupBy !== undefined) {
                localVarQueryParameter['groupBy'] = groupBy;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Track a metric
         * @param {TrackMetricRequest} trackMetricRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackMetric: async (trackMetricRequest: TrackMetricRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackMetricRequest' is not null or undefined
            assertParamExists('trackMetric', 'trackMetricRequest', trackMetricRequest)
            const localVarPath = `/api/v1/metrics/track`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trackMetricRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MetricsApi - functional programming interface
 * @export
 */
export const MetricsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MetricsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Export metrics
         * @param {MetricsExportRequest} metricsExportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportMetrics(metricsExportRequest: MetricsExportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportMetrics(metricsExportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.exportMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get aggregated metrics
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAggregatedMetrics(startDate: string, endDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AggregatedMetrics>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAggregatedMetrics(startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.getAggregatedMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get available metric types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMetricTypes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMetricTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.getMetricTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get metrics summary
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMetricsSummary(startDate: string, endDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMetricsSummary(startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.getMetricsSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Query metrics
         * @param {string} startDate Start date for metrics query
         * @param {string} endDate End date for metrics query
         * @param {QueryMetricsTypeEnum} [type] Metric type filter
         * @param {QueryMetricsGroupByEnum} [groupBy] Group metrics by time period
         * @param {string} [limit] Maximum number of results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryMetrics(startDate: string, endDate: string, type?: QueryMetricsTypeEnum, groupBy?: QueryMetricsGroupByEnum, limit?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MetricDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryMetrics(startDate, endDate, type, groupBy, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.queryMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Track a metric
         * @param {TrackMetricRequest} trackMetricRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trackMetric(trackMetricRequest: TrackMetricRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackMetric200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trackMetric(trackMetricRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.trackMetric']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MetricsApi - factory interface
 * @export
 */
export const MetricsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MetricsApiFp(configuration)
    return {
        /**
         * 
         * @summary Export metrics
         * @param {MetricsApiExportMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportMetrics(requestParameters: MetricsApiExportMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.exportMetrics(requestParameters.metricsExportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get aggregated metrics
         * @param {MetricsApiGetAggregatedMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregatedMetrics(requestParameters: MetricsApiGetAggregatedMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AggregatedMetrics> {
            return localVarFp.getAggregatedMetrics(requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get available metric types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetricTypes(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getMetricTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get metrics summary
         * @param {MetricsApiGetMetricsSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetricsSummary(requestParameters: MetricsApiGetMetricsSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getMetricsSummary(requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Query metrics
         * @param {MetricsApiQueryMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryMetrics(requestParameters: MetricsApiQueryMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<MetricDto>> {
            return localVarFp.queryMetrics(requestParameters.startDate, requestParameters.endDate, requestParameters.type, requestParameters.groupBy, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Track a metric
         * @param {MetricsApiTrackMetricRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackMetric(requestParameters: MetricsApiTrackMetricRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrackMetric200Response> {
            return localVarFp.trackMetric(requestParameters.trackMetricRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MetricsApi - interface
 * @export
 * @interface MetricsApi
 */
export interface MetricsApiInterface {
    /**
     * 
     * @summary Export metrics
     * @param {MetricsApiExportMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApiInterface
     */
    exportMetrics(requestParameters: MetricsApiExportMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @summary Get aggregated metrics
     * @param {MetricsApiGetAggregatedMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApiInterface
     */
    getAggregatedMetrics(requestParameters: MetricsApiGetAggregatedMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AggregatedMetrics>;

    /**
     * 
     * @summary Get available metric types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApiInterface
     */
    getMetricTypes(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>>;

    /**
     * 
     * @summary Get metrics summary
     * @param {MetricsApiGetMetricsSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApiInterface
     */
    getMetricsSummary(requestParameters: MetricsApiGetMetricsSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Query metrics
     * @param {MetricsApiQueryMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApiInterface
     */
    queryMetrics(requestParameters: MetricsApiQueryMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<MetricDto>>;

    /**
     * 
     * @summary Track a metric
     * @param {MetricsApiTrackMetricRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApiInterface
     */
    trackMetric(requestParameters: MetricsApiTrackMetricRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrackMetric200Response>;

}

/**
 * Request parameters for exportMetrics operation in MetricsApi.
 * @export
 * @interface MetricsApiExportMetricsRequest
 */
export interface MetricsApiExportMetricsRequest {
    /**
     * 
     * @type {MetricsExportRequest}
     * @memberof MetricsApiExportMetrics
     */
    readonly metricsExportRequest: MetricsExportRequest
}

/**
 * Request parameters for getAggregatedMetrics operation in MetricsApi.
 * @export
 * @interface MetricsApiGetAggregatedMetricsRequest
 */
export interface MetricsApiGetAggregatedMetricsRequest {
    /**
     * 
     * @type {string}
     * @memberof MetricsApiGetAggregatedMetrics
     */
    readonly startDate: string

    /**
     * 
     * @type {string}
     * @memberof MetricsApiGetAggregatedMetrics
     */
    readonly endDate: string
}

/**
 * Request parameters for getMetricsSummary operation in MetricsApi.
 * @export
 * @interface MetricsApiGetMetricsSummaryRequest
 */
export interface MetricsApiGetMetricsSummaryRequest {
    /**
     * 
     * @type {string}
     * @memberof MetricsApiGetMetricsSummary
     */
    readonly startDate: string

    /**
     * 
     * @type {string}
     * @memberof MetricsApiGetMetricsSummary
     */
    readonly endDate: string
}

/**
 * Request parameters for queryMetrics operation in MetricsApi.
 * @export
 * @interface MetricsApiQueryMetricsRequest
 */
export interface MetricsApiQueryMetricsRequest {
    /**
     * Start date for metrics query
     * @type {string}
     * @memberof MetricsApiQueryMetrics
     */
    readonly startDate: string

    /**
     * End date for metrics query
     * @type {string}
     * @memberof MetricsApiQueryMetrics
     */
    readonly endDate: string

    /**
     * Metric type filter
     * @type {'PAYMENT_PROCESSED' | 'PAYMENT_FAILED' | 'SUBSCRIPTION_CREATED' | 'SUBSCRIPTION_CANCELLED' | 'USER_LOGIN' | 'API_REQUEST'}
     * @memberof MetricsApiQueryMetrics
     */
    readonly type?: QueryMetricsTypeEnum

    /**
     * Group metrics by time period
     * @type {'HOUR' | 'DAY' | 'WEEK' | 'MONTH'}
     * @memberof MetricsApiQueryMetrics
     */
    readonly groupBy?: QueryMetricsGroupByEnum

    /**
     * Maximum number of results
     * @type {string}
     * @memberof MetricsApiQueryMetrics
     */
    readonly limit?: string
}

/**
 * Request parameters for trackMetric operation in MetricsApi.
 * @export
 * @interface MetricsApiTrackMetricRequest
 */
export interface MetricsApiTrackMetricRequest {
    /**
     * 
     * @type {TrackMetricRequest}
     * @memberof MetricsApiTrackMetric
     */
    readonly trackMetricRequest: TrackMetricRequest
}

/**
 * MetricsApi - object-oriented interface
 * @export
 * @class MetricsApi
 * @extends {BaseAPI}
 */
export class MetricsApi extends BaseAPI implements MetricsApiInterface {
    /**
     * 
     * @summary Export metrics
     * @param {MetricsApiExportMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public exportMetrics(requestParameters: MetricsApiExportMetricsRequest, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).exportMetrics(requestParameters.metricsExportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get aggregated metrics
     * @param {MetricsApiGetAggregatedMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public getAggregatedMetrics(requestParameters: MetricsApiGetAggregatedMetricsRequest, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).getAggregatedMetrics(requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get available metric types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public getMetricTypes(options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).getMetricTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get metrics summary
     * @param {MetricsApiGetMetricsSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public getMetricsSummary(requestParameters: MetricsApiGetMetricsSummaryRequest, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).getMetricsSummary(requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Query metrics
     * @param {MetricsApiQueryMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public queryMetrics(requestParameters: MetricsApiQueryMetricsRequest, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).queryMetrics(requestParameters.startDate, requestParameters.endDate, requestParameters.type, requestParameters.groupBy, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Track a metric
     * @param {MetricsApiTrackMetricRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public trackMetric(requestParameters: MetricsApiTrackMetricRequest, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).trackMetric(requestParameters.trackMetricRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const QueryMetricsTypeEnum = {
    PaymentProcessed: 'PAYMENT_PROCESSED',
    PaymentFailed: 'PAYMENT_FAILED',
    SubscriptionCreated: 'SUBSCRIPTION_CREATED',
    SubscriptionCancelled: 'SUBSCRIPTION_CANCELLED',
    UserLogin: 'USER_LOGIN',
    ApiRequest: 'API_REQUEST'
} as const;
export type QueryMetricsTypeEnum = typeof QueryMetricsTypeEnum[keyof typeof QueryMetricsTypeEnum];
/**
 * @export
 */
export const QueryMetricsGroupByEnum = {
    Hour: 'HOUR',
    Day: 'DAY',
    Week: 'WEEK',
    Month: 'MONTH'
} as const;
export type QueryMetricsGroupByEnum = typeof QueryMetricsGroupByEnum[keyof typeof QueryMetricsGroupByEnum];
